import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function ContractsIcon({ className }: IconProps) {
  return (
    <svg
      width="69"
      height="69"
      viewBox="0 0 69 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1147_1848)">
        <path
          d="M61.0912 69V10.9613C57.7906 9.55225 51.8953 3.0045 50.1101 0H3.13448C1.41155 0 0 1.40901 0 3.12883V60.6081C0 65.2288 3.75722 69 8.40704 69H61.0912Z"
          fill="#EAEDF8"
        />
        <path
          d="M8.51074 68.9999C12.5793 68.9999 15.9214 65.9954 16.4611 62.0792C16.5441 61.4575 17.0631 60.981 17.7066 60.981H67.7337C68.5225 60.981 69.1245 61.6855 68.9791 62.4521C68.2941 66.1819 65.0143 68.9999 61.0911 68.9999H8.51074Z"
          fill="#00C4B3"
        />
        <path
          d="M30.5353 13.5306H6.37282C5.89538 13.5306 5.50098 13.1369 5.50098 12.6603C5.50098 12.1837 5.89538 11.79 6.37282 11.79H30.556C31.0335 11.79 31.4279 12.1837 31.4279 12.6603C31.4279 13.1369 31.0335 13.5306 30.556 13.5306"
          fill="#00416B"
        />
        <path
          d="M54.7188 20.555H24.9724C24.495 20.555 24.1006 20.1613 24.1006 19.6847C24.1006 19.2081 24.495 18.8145 24.9724 18.8145H54.7188C55.1963 18.8145 55.5907 19.2081 55.5907 19.6847C55.5907 20.1613 55.1963 20.555 54.7188 20.555Z"
          fill="#00416B"
        />
        <path
          d="M19.3882 20.555H6.37282C5.89538 20.555 5.50098 20.1613 5.50098 19.6847C5.50098 19.2081 5.89538 18.8145 6.37282 18.8145H19.3882C19.8656 18.8145 20.26 19.2081 20.26 19.6847C20.26 20.1613 19.8656 20.555 19.3882 20.555Z"
          fill="#00416B"
        />
        <path
          d="M54.7183 27.5794H39.8347C39.3573 27.5794 38.9629 27.1857 38.9629 26.7091C38.9629 26.2326 39.3573 25.8389 39.8347 25.8389H54.7183C55.1957 25.8389 55.5901 26.2326 55.5901 26.7091C55.5901 27.1857 55.1957 27.5794 54.7183 27.5794Z"
          fill="#00416B"
        />
        <path
          d="M34.251 27.5794H6.37282C5.89538 27.5794 5.50098 27.1857 5.50098 26.7091C5.50098 26.2326 5.89538 25.8389 6.37282 25.8389H34.2717C34.7492 25.8389 35.1436 26.2326 35.1436 26.7091C35.1436 27.1857 34.7492 27.5794 34.2717 27.5794"
          fill="#00416B"
        />
        <path
          d="M54.7184 34.6038H24.5984C24.121 34.6038 23.7266 34.2101 23.7266 33.7336C23.7266 33.257 24.121 32.8633 24.5984 32.8633H54.7184C55.1959 32.8633 55.5903 33.257 55.5903 33.7336C55.5903 34.2101 55.1959 34.6038 54.7184 34.6038Z"
          fill="#00416B"
        />
        <path
          d="M19.0145 34.6038H6.37282C5.89538 34.6038 5.50098 34.2101 5.50098 33.7336C5.50098 33.257 5.89538 32.8633 6.37282 32.8633H19.0145C19.492 32.8633 19.8864 33.257 19.8864 33.7336C19.8864 34.2101 19.492 34.6038 19.0145 34.6038Z"
          fill="#00416B"
        />
        <path
          d="M54.7183 41.6072H39.8347C39.3573 41.6072 38.9629 41.2135 38.9629 40.737C38.9629 40.2604 39.3573 39.8667 39.8347 39.8667H54.7183C55.1957 39.8667 55.5901 40.2604 55.5901 40.737C55.5901 41.2135 55.1957 41.6072 54.7183 41.6072Z"
          fill="#00416B"
        />
        <path
          d="M34.251 41.6072H6.37282C5.89538 41.6072 5.50098 41.2135 5.50098 40.737C5.50098 40.2604 5.89538 39.8667 6.37282 39.8667H34.2717C34.7492 39.8667 35.1436 40.2604 35.1436 40.737C35.1436 41.2135 34.7492 41.6072 34.2717 41.6072"
          fill="#00416B"
        />
        <path
          d="M54.7184 48.6317H24.5984C24.121 48.6317 23.7266 48.238 23.7266 47.7614C23.7266 47.2848 24.121 46.8911 24.5984 46.8911H54.7184C55.1959 46.8911 55.5903 47.2848 55.5903 47.7614C55.5903 48.238 55.1959 48.6317 54.7184 48.6317Z"
          fill="#00416B"
        />
        <path
          d="M19.0145 48.6317H6.37282C5.89538 48.6317 5.50098 48.238 5.50098 47.7614C5.50098 47.2848 5.89538 46.8911 6.37282 46.8911H19.0145C19.492 46.8911 19.8864 47.2848 19.8864 47.7614C19.8864 48.238 19.492 48.6317 19.0145 48.6317Z"
          fill="#00416B"
        />
        <path
          d="M54.7183 55.6561H39.8347C39.3573 55.6561 38.9629 55.2624 38.9629 54.7858C38.9629 54.3092 39.3573 53.9155 39.8347 53.9155H54.7183C55.1957 53.9155 55.5901 54.3092 55.5901 54.7858C55.5901 55.2624 55.1957 55.6561 54.7183 55.6561Z"
          fill="#00416B"
        />
        <path
          d="M50.1104 0L61.0914 10.9613H51.7918C50.8576 10.9613 50.1104 10.2153 50.1104 9.28288V0Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1848">
          <rect width="69" height="69" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
